import { all, call, put, takeLatest } from 'redux-saga/effects';
import { deleteRequest, patchRequest, postRequest, getRequest, putRequest, postDeleteRequest } from '../../../helpers/axiosClient';
import actions from './actions';

export function* postDetails(params) {
    try {
        const response = yield call(() => postRequest(`${params.url}`, params.details));
        yield put({
            type: actions.CREATE_DETAILS_SUCCESS,
            payload: `${params?.typeTitle ? params?.typeTitle : `${params.title} ${params.use ? params.use : 'added'} successfully`}`,
            data: response.data
        });
    } catch (error) {
        yield put({ type: actions.CREATE_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}


export function* deleteDetails(params) {
    try {
        let response = '';
        if (params.action === 'post') {
            response = yield call(() => postRequest(`${params.url}`));
        } else {
            if (params.details) {
                response = yield call(() => postDeleteRequest(`${params.url}`, params.details));
            } else {
                response = yield call(() => deleteRequest(`${params.url}/${params.id}`));
            }
        }
        yield put({
            type: actions.DELETE_DETAILS_SUCCESS,
            payload: `${params?.titleType ? params?.titleType : `${params.title} deleted successfully`}`,
            data: response.data
        });
    } catch (error) {
        yield put({ type: actions.DELETE_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* editDetails(params) {
    try {
        let response = '';
        if (params.method === 'put') {
            response = yield call(() => putRequest(`${params.url}${params.id ? '/' + params.id : ''}`, params.details));
        } else {
            response = yield call(() => patchRequest(`${params.url}${params.id ? '/' + params.id : ''}${params.slug ? '/' + params.slug : ''}`, params.details));
        }

        yield put({
            type: actions.EDIT_DETAILS_SUCCESS,
            payload: params.titleFull ? params.titleFull : `${params.title} updated successfully`,
            data: response.data
        });
    } catch (error) {
        yield put({ type: actions.EDIT_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* readDetails(params) {
    try {
        let response = '';
        if (params.id) {
            response = yield call(() => getRequest(`${params.url}/${params.id}`));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.READ_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.READ_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* getDetails(params) {
    try {
        let response = '';
        if (params?.method === 'post') {
            response = yield call(() => postRequest(`${params.url}`, params.details));
        } else {
            if (params.filter) {
                response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
            } else {
                response = yield call(() => getRequest(`${params.url}`));
            }
        }
        yield put({
            skip: params.skip,
            type: actions.GET_DETAILS_SUCCESS,
            payload: params.title ? `${params.title} added successfully` : '',
            data: response?.data || []
        });
    } catch (error) {
        yield put({ type: actions.GET_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* importDetails(params) {
    try {
        let response = '';
        if (params.importType === 'insert') {
            response = yield call(() => postRequest(`${params.url}`, params.details));
        } else {
            response = yield call(() => putRequest(`${params.url}`, params.details));
        }
        yield put({
            type: actions.IMPORT_SUCCESS,
            payload: `${params.title} imported successfully`,
            data: response.data
        });
    } catch (error) {
        yield put({ type: actions.IMPORT_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* exportDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.EXPORT_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.EXPORT_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* pdfDetails(params) {
    try {
        let response = yield call(() => postRequest(`${params.url}`, params.details));
        yield put({
            type: actions.PDFGENERATE_SUCCESS,
            payload: `${params.title} Download Successfully`,
            data: response.data
        });
    } catch (error) {
        yield put({ type: actions.PDFGENERATE_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* updateCall(params) {
    try {
        let response = yield call(() => patchRequest(`${params.url}`, params.details));
        yield put({
            type: actions.UPDATE_SUCCESS,
            payload: params.titleFull ? params.titleFull : `${params.title} updated successfully`,
            data: response.data
        });
    } catch (error) {
        return error;
    }
}



export function* getClearDetails() {
    yield put({
        type: actions.CLEAR_CRUD_DETAILS_SUCCESS,
    });
}

export function* clearGetDetails() {
    yield put({
        type: actions.CLEAR_GET_DETAILS_SUCCESS,
    });
}

export default function* crudSaga() {
    yield all([
        takeLatest(actions.CREATE_DETAILS_START, postDetails),
        takeLatest(actions.READ_DETAILS_START, readDetails),
        takeLatest(actions.EDIT_DETAILS_START, editDetails),
        takeLatest(actions.DELETE_DETAILS_START, deleteDetails),
        takeLatest(actions.GET_DETAILS_START, getDetails),
        takeLatest(actions.CLEAR_GET_DETAILS_START, clearGetDetails),
        takeLatest(actions.IMPORT_START, importDetails),
        takeLatest(actions.EXPORT_START, exportDetails),
        takeLatest(actions.PDFGENERATE_START, pdfDetails),
        takeLatest(actions.UPDATE_START, updateCall),
        takeLatest(actions.CLEAR_CRUD_DETAILS_START, getClearDetails)
    ]);
}